import { ReportType } from "constants/reports/report-type";

import { handlingTimeByStatusDeserializer } from "./data-deserializers/handling-time-by-status-deserializer";
import { deserializeLast7Days } from "./data-deserializers/last-7-days-deserializer";
import { newTicketsDeserializer } from "./data-deserializers/new-tickets-deserializer";
import { deserializeScheduledReports } from "./data-deserializers/scheduled-reports-deserializer";
import { solvedClosedTicketsDeserializer } from "./data-deserializers/solved-closed-tickets-deserializer";
import { ticketFirstResponseTimeDeserializer } from "./data-deserializers/ticket-first-response-time-deserializer";
import { ticketRatingsDeserializer } from "./data-deserializers/ticket-ratings-deserializer";
import { ticketResolutionTimeDeserializer } from "./data-deserializers/ticket-resolution-time-deserializer";

export default {
  [ReportType.Last7days]: deserializeLast7Days,
  [ReportType.TicketRatings]: ticketRatingsDeserializer,
  [ReportType.ScheduledReports]: deserializeScheduledReports,
  [ReportType.SolvedAndClosed]: solvedClosedTicketsDeserializer,
  [ReportType.TicketFirstResponseTime]: ticketFirstResponseTimeDeserializer,
  [ReportType.NewTickets]: newTicketsDeserializer,
  [ReportType.TicketResolutionTime]: ticketResolutionTimeDeserializer,
  [ReportType.HandlingTimeByStatus]: handlingTimeByStatusDeserializer,
};
